export const BG_TYPE_IMAGE = 'image'
export const BG_TYPE_COLOR = 'color'

export const SB_DEFAULT_IMAGE_OPTIONS = { format: 'webp', quality: 80 }
export const SB_IMAGE_PROVIDER = { provider: 'storyblok' }
